import { render, staticRenderFns } from "./RipaFormSummaryDetail.vue?vue&type=template&id=67338f15"
import script from "./RipaFormSummaryDetail.vue?vue&type=script&lang=js"
export * from "./RipaFormSummaryDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports